import { useEffect, type ReactNode } from "react";
import { X } from "./icons";

interface Props {
  open: boolean;
  onClose: () => void;
  title?: string;
  subtitle?: string;
  children: ReactNode;
  size?: "sm" | "md" | "lg" | "xl";
}

export default function Modal({ open, onClose, title, subtitle, children, size = "md" }: Props) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="modal-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div className={`modal modal--${size}`} onClick={(e) => e.stopPropagation()}>
        {(title || subtitle) && (
          <div className="modal__head">
            <div>
              {title && <div className="modal__title">{title}</div>}
              {subtitle && <div className="modal__subtitle">{subtitle}</div>}
            </div>
            <button className="icon-btn" onClick={onClose} aria-label="Close">
              <X />
            </button>
          </div>
        )}
        {!title && !subtitle && (
          <button className="modal__close-only icon-btn" onClick={onClose} aria-label="Close">
            <X />
          </button>
        )}
        <div className="modal__body">{children}</div>
      </div>
    </div>
  );
}
